<template>
  <div class="pdxtfb-warp">
    <SvgPanZoom
      style="width: 100%; height: 100%;"
      :zoomEnabled="true"
      :controlIconsEnabled="false"
      :fit="false"
      :center="false"
      :minZoom="0.5"
      id="svgbox"
    >
      <svg class="svgClass" aria-hidden="true">
        <use xlink:href="#icon-water" />
      </svg>
    </SvgPanZoom>
  </div>
</template>

<script>
import SvgPanZoom from "vue-svg-pan-zoom";
import * as utils from "@/utils/index.js";
import water from "@/assets/svg/water.svg";
import socket from "@/utils/websocket.js"; // 引用websocket
export default {
  components: {
    SvgPanZoom,
  },
  data() {
    return {
      timer: null,
      sxtfbtViewId: "",
      pointCode: "",
      landscape: [],
      jsonData: {},
      viewNodes: [],
      webSock: {
        ip: "",
        port: "",
        key: "",
        path: "",
      },
    };
  },
  created() {
    this.init();
  },
  mounted() {
    this.timer = setInterval(this.init, 30 * 1000);
    let doms = document.querySelectorAll("g");
    for (let index = 0; index < doms.length; index++) {
      const domItem = doms[index];
    }
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    async init() {
      let fid = "0";
      let pointCode = "401";
      let special = [];
      const res = await this.$api.frontEndPageCustomParam.getMyFrontEndPageCustomParam(
        0,
        "/zxjc/sxtfbt",
        null
      );
      if (!res) {
        return;
      }
      fid = utils.findDataByParam("sxtfbtView", false, res.data);
      pointCode = utils.findDataByParam("pointCode", false, res.data);
      special =
        utils.findDataByParam("special", false, res.data) == ""
          ? []
          : JSON.parse(res.data["special"]);
      //获取视图的树数据
      const treeNodeResult = await this.$api.view.getViewTreeNodes(fid);
      let viewNodes = [];
      let measures = [];
      for (let i = 0; i < treeNodeResult.data.length; i++) {
        let item = treeNodeResult.data[i];
        let measuresItem = {};
        let specialItem = special.find((obj) => {
          return obj.id == data[i].measureId;
        });
        measuresItem.measureId = item.measureId;
        if (specialItem) {
          measuresItem.pointNumber = specialItem.pointNumber;
          measuresItem.pointCode = specialItem.pointCode;
        } else {
          measuresItem.pointNumber = 0;
          measuresItem.pointCode = pointCode;
        }
        measures.push(measuresItem);
        viewNodes.push(item);
      }
      this.viewNodes = viewNodes;
      const dayResult = await this.$api.quantity.getQuantityDay3(
        measures,
        utils.formatDate(new Date(), "yyyy-MM-dd") + " 00:00:00",
        utils.formatDate(new Date(), "yyyy-MM-dd") + " 23:59:59",
        null
      );
      if (!dayResult) {
        return;
      }
      this.bindData(dayResult.data);
    },
    bindData(data) {
      for (let i = 0; i < data.length; i++) {
        let item = this.viewNodes.find((obj) => {
          return obj.measureId == data[i].measureId;
        });
        if (item) {
          item.value = data[i].data[0][0]
            ? data[i].data[0][0].value.toFixed(2)
            : "-";
        }
        var doms = document.querySelectorAll(
          "[measureId='" + item.measureId + "']"
        );
        if (doms.length > 0)
          for (var index = 0; index < doms.length; index++) {
            let domItem = doms[index];
            domItem.innerHTML = item.value;
          }
      }
    },
  },
};
</script>

<style lang="scss">
.pdxtfb-warp {
  width: 100%;
  height: 100%;
  background: #fff;
}
.svgClass {
  width: 100%;
  height: 100%;
}
.legend {
  display: flex;
  flex-flow: column;
  font-size: 14px;
  position: absolute;
  bottom: 0px;
  right: 0px;
}
.cl {
  display: flex;
  align-items: center;
  padding-bottom: 10px;
}
.rectangle {
  width: 20px;
  height: 20px;
  margin-right: 10px;
}
.bg-402F78 {
  background: #402f78;
}
.bg-007947 {
  background: #007947;
}
.bg-EC6901 {
  background: #ec6901;
}
</style>
